import React, { FC, useMemo, useState } from 'react'

import { getRebateBalanceAmounts } from '../../../../../../lib/rewards/rebates'
import { DetailsPayoutsCardSecondaryButton } from '../DetailsPayoutsCard'
import { RebatesRequestPayoutModal } from './RebatesRequestPayoutModal'

export interface RebatesRequestPayoutButtonProps {
  availableBalance: {
    rebateBalance: number
  }
  refetchBalance: () => Promise<void>
}

export const RebatesRequestPayoutButton: FC<RebatesRequestPayoutButtonProps> = ({
  availableBalance,
  refetchBalance,
}) => {
  const { rebateBalance } = availableBalance
  const [isPayoutRequestCreated, setIsPayoutRequestCreated] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { isPayoutAvailable, remaining } = useMemo(
    () => getRebateBalanceAmounts({ rebateBalance }),
    [rebateBalance],
  )
  const canRequestPayout = !isPayoutRequestCreated && isPayoutAvailable.value

  const onButtonClick = () => setIsModalOpen(true)
  const onCloseModal = () => setIsModalOpen(false)
  const onPayoutRequestSuccess = () => {
    refetchBalance().then(() => {
      setIsPayoutRequestCreated(true)
      setIsModalOpen(false)
    })
  }

  return (
    <>
      <DetailsPayoutsCardSecondaryButton
        variant="outlined"
        onClick={onButtonClick}
        disabled={!canRequestPayout}
      >
        {canRequestPayout
          ? 'Request Payout'
          : isPayoutRequestCreated
            ? 'Payout in Progress'
            : `${remaining.formatted} until payout available`}
      </DetailsPayoutsCardSecondaryButton>
      {isModalOpen && (
        <RebatesRequestPayoutModal
          rebateBalance={rebateBalance}
          isOpen={isModalOpen}
          onClose={onCloseModal}
          onSuccess={onPayoutRequestSuccess}
        />
      )}
    </>
  )
}
